// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XRVRs","left":"styles_left__9dzek"};